import axios from 'axios';

export default axios.create({
    baseURL: 'https://regtronweb.com.br/cidtechweb/api'
    //baseURL: 'http://api.marcus:8080/cidtechweb/api'
});